import type { ReactNode } from "react";
import Cloud from "./Cloud";
import Aeroplane from "./Aeroplane";

interface SkyBackgroundProps {
  children: ReactNode;
}

const SkyBackground = ({ children }: SkyBackgroundProps) => {
  return (
    <div className="sky-background">
      <div className="sky-background-decor" aria-hidden="true">
        <Cloud position="first" />
        <Cloud position="second" />
        <Cloud position="third" />
        <Cloud position="fourth" />
        <Cloud position="fifth" />
        <Cloud position="sixth" />
        <Cloud position="seventh" />
        <Cloud position="eighth" />
        <Aeroplane variant="first" />
        <Aeroplane variant="second" />
        <Aeroplane variant="third" />
      </div>
      {children}
    </div>
  );
};

export default SkyBackground;
